import {Component, OnInit, ViewChild, AfterViewInit, OnChanges, Input, Output, EventEmitter} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, CRMService, ProductService} from '../_services';
import {FormBuilder} from '@angular/forms';
import {CrudSaveComponent} from '../_directives';
import {CRM, Product} from "../_models";
import {EMPTY} from "rxjs";
import {mergeMap, takeUntil} from "rxjs/operators";
import {ProductMarketplaceFieldsComponent} from './product-marketplace-fields.component'
import {ProductBasicFieldsComponent} from './product-basic-fields.component'
import {ProductPathFieldsComponent} from './product-path-fields.component'

@Component({
  moduleId: module.id.toString(),
  selector: 'product-form',
  templateUrl: './product-edit.component.html'
})
export class ProductEditComponent extends CrudSaveComponent implements OnInit, OnChanges, AfterViewInit {
  product: Product;
  crm: CRM;
  ready = false;

  @ViewChild(ProductMarketplaceFieldsComponent, { static: false }) productMarketplaceFields: ProductMarketplaceFieldsComponent;
  @ViewChild(ProductBasicFieldsComponent, { static: false }) productBasicFields: ProductBasicFieldsComponent;
  @ViewChild(ProductPathFieldsComponent, { static: false }) productPathFields: ProductPathFieldsComponent;
  @Input('productId') productId: string | number;
  @Output('save') onSave: EventEmitter<any> = new EventEmitter<any>();
  @Output('cancel') onCancel: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected productService: ProductService,
    private crmService: CRMService,
    private formBuilder: FormBuilder,
    protected alertService: AlertService
  ) {
    super(router, location, route, productService, alertService);
    this.isNew = false;
    this.isPartial = true;
    this.objectName = 'Product';
  }

  ngOnInit() {
    this.setForm(this.formBuilder.group({}));
    this.updateForm();
  }

  ngOnChanges(): void {
    this.updateForm();
  }

  get allFormsValid() {
    return (
      this.form.valid &&
      this.productBasicFields && this.productBasicFields.form.valid &&
      this.productPathFields && this.productPathFields.form.valid &&
      this.productMarketplaceFields && this.productMarketplaceFields.form.valid
    );
  }

  private updateForm() {
    this.ready = false;

    if (this.form) {
      this.resetForm();

      if (this.productId) {
        this.loading = true;
        this.id = this.productId;

        this.productService.get(this.id)
          .pipe(takeUntil(this.destroy$), mergeMap((product: Product) => {
            if (product) {
              this.product = product;
              this.form.patchValue(this.product);
              this.addProductFields();
              this.form.updateValueAndValidity();
              this.loading = false;

              return this.crmService.get(product.crm);
            }

            return EMPTY;
          })).subscribe(
            (crm: CRM) => {
              this.crm = crm;
            },
            error => {
              this.handleError(error);
              this.loading = false;
            }
          );
        }
        else {
          this.addProductFields();
        }

      setTimeout(() => this.ready = true, 0); // this is needed to force the tinymce editor to reload
    }
  }

  ngAfterViewInit() {
    setTimeout(() => this.addProductFields(), 0);
  }

  private addProductFields() {
    if (this.product) {
      if (this.productBasicFields && !this.form.get('productBasicFields')) {
        this.form.addControl('productBasicFields', this.productBasicFields.form)
      }

      if (this.productMarketplaceFields && !this.form.get('productMarketplaceFields')) {
        this.form.addControl('productMarketplaceFields', this.productMarketplaceFields.form)
      }

      if (this.productPathFields && !this.form.get('productPathFields')) {
        this.form.addControl('productPathFields', this.productPathFields.form)
      }
    }
  }

  protected getFormData() {
    return Object.assign({},
      this.productBasicFields ? this.productBasicFields.getFormData() : {},
      this.productMarketplaceFields ? this.productMarketplaceFields.getFormData() : {},
      this.productPathFields ? this.productPathFields.getFormData() : {}
    );
  }

  protected onSaveComplete(data) {
    this.loading = false;
    this.onSave.emit(data);
  }

  onSubmit() {
    this.submitted = true;
    if (this.allFormsValid) {
      this.loading = true;
      super.onSubmit(); //normal object update
    } else {
      this.loading = false;
    }
  }

  closeDialog() {
    this.onCancel.emit()
  }
}
